import { isSuited, tileNumber, isTerminalOrHonor, NUM_TILE_TYPES } from './tiles';
import { TileCounts } from './hand';

/** 남은 카운트가 전부 면자로 분해되는지 재귀 판정.
 *  주의: 인자 c를 재귀 중 변이하지만 반환 전 항상 복원한다(백트래킹).
 *  외부에서 직접 호출하지 말 것 — isStandardAgari가 복제본을 넘긴다. */
function canFormMelds(c: number[]): boolean {
  let i = 0;
  while (i < NUM_TILE_TYPES && c[i] === 0) i++;
  if (i === NUM_TILE_TYPES) return true; // 다 분해됨

  // 각자(刻子): 같은 패 3장
  if (c[i] >= 3) {
    c[i] -= 3;
    if (canFormMelds(c)) { c[i] += 3; return true; }
    c[i] += 3;
  }
  // 순자(順子): i, i+1, i+2 (같은 수패 안에서만)
  if (isSuited(i) && tileNumber(i) <= 7 && c[i + 1] > 0 && c[i + 2] > 0) {
    c[i]--; c[i + 1]--; c[i + 2]--;
    if (canFormMelds(c)) { c[i]++; c[i + 1]++; c[i + 2]++; return true; }
    c[i]++; c[i + 1]++; c[i + 2]++;
  }
  return false;
}

/** 표준형: 어떤 패를 작두(2장)로 삼고 나머지가 4면자로 분해되면 화료. */
export function isStandardAgari(counts: TileCounts): boolean {
  const c = counts.slice();
  for (let i = 0; i < NUM_TILE_TYPES; i++) {
    if (c[i] >= 2) {
      c[i] -= 2;
      if (canFormMelds(c)) { c[i] += 2; return true; }
      c[i] += 2;
    }
  }
  return false;
}

/** 칠대자: 서로 다른 7종류가 정확히 2장씩. (4장 1종은 불성립) */
export function isSevenPairs(counts: TileCounts): boolean {
  let pairs = 0;
  for (let i = 0; i < NUM_TILE_TYPES; i++) {
    if (counts[i] === 0) continue;
    if (counts[i] === 2) pairs++;
    else return false;
  }
  return pairs === 7;
}

/** 국사무쌍: 13종 요구패가 모두 1장 이상이며 그중 하나가 2장(나머지 1장). */
export function isKokushi(counts: TileCounts): boolean {
  let kinds = 0;
  let hasPair = false;
  for (let i = 0; i < NUM_TILE_TYPES; i++) {
    if (counts[i] === 0) continue;
    if (!isTerminalOrHonor(i)) return false; // 중간패 섞이면 불성립
    kinds++;
    if (counts[i] === 2) hasPair = true;
    else if (counts[i] !== 1) return false;  // 3장 이상 불가
  }
  return kinds === 13 && hasPair;
}

export function isAgari(counts: TileCounts): boolean {
  return isStandardAgari(counts) || isSevenPairs(counts) || isKokushi(counts);
}
